import React, { createContext, useState } from 'react';
import PropTypes from 'prop-types';

const HeaderContext = createContext(null);

function HeaderProvider({ children }) {
  const [headerProps, setHeaderProps] = useState({});

  const setTitle = title => {
    const newHeaderProps = { ...headerProps };
    newHeaderProps.title = title;
    setHeaderProps(newHeaderProps);
  };

  const setButtonRight = buttonRight => {
    const newHeaderProps = { ...headerProps };
    newHeaderProps.buttonRight = buttonRight;
    setHeaderProps(newHeaderProps);
  };

  return (
    <HeaderContext.Provider
      value={{
        headerProps,
        setHeaderProps,
        setTitle,
        setButtonRight,
      }}
    >
      {children}
    </HeaderContext.Provider>
  );
}

HeaderProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.array,
  ]).isRequired,
};

export { HeaderProvider, HeaderContext };
